import moment from 'moment'
import React from 'react'
import { employerSide } from '../../routerHistory'
import { FormatEmails } from '../../utils/employer/stringArrayHandle.utils'

const AssignmentDetails = ({
  t,
  classes,
  assignmentType,
  salaryModel,
  areaOfWorkDict,
  industryRender,
  offeredAssignmentStatus, // offered assignment
  company_name,
  location,
  amount,
  contract_salary,
  unit_price,
  hourly_rate,
  weekly_hours,
  job_title,
  assignment_begins,
  assignment_ends,
  status = 0,
  agreement_status_entrepreneur,
  industry,
  industry_type,
  last_date_of_application,
  type_of_employment,
  notice_period,
  assignment_contents,
  job_description,
  enterpreneur_email = '', // Employer side
  lightEntreList = []
}) => {
  const emailList = enterpreneur_email?.split(',').map((e) => e.trim())
  const employmentLabels = {
    weekdays: employerSide
      ? 'employer.assignments.label8a'
      : 'assignment.label8a',
    morning: employerSide
      ? 'employer.assignments.label8c'
      : 'assignment.label8c',
    evening: employerSide
      ? 'employer.assignments.label8e'
      : 'assignment.label8e',
    night: employerSide ? 'employer.assignments.label8b' : 'assignment.label8b',
    weekends: employerSide
      ? 'employer.assignments.label8d'
      : 'assignment.label8d',
    remote: employerSide
      ? 'employer.assignments.label8f'
      : 'assignment.label8f',
    undefined_hours: employerSide
      ? 'employer.assignments.label8g'
      : 'assignment.label8g'
  }

  const translatedTypeOfEmployment =
    type_of_employment?.split(',').map(
      (item) => t(employmentLabels[item] || item) // fallback to item if no translation key is found
    ) ?? []

  const formattedTypeOfEmployment = translatedTypeOfEmployment
    .map((item) => item.replace('_', ' '))
    .join(', ')

  return (
    <div style={{ margin: '0 25px' }}>
      <div
        className="row"
        style={{
          border: '1px solid #D3D3D3',
          borderRadius: '5px',
          padding: '15px'
        }}
      >
        {enterpreneur_email !== '' && enterpreneur_email !== null ? (
          <div className={classes.previewField} style={{ paddingLeft: '15px' }}>
            <p className={classes.previewLabel}>
              {employerSide ? t('employer.assignments.label12') : ''}
            </p>
            <p className={classes.previewValue}>
              {/* {renderEmail(
                emailStringToArray(enterpreneur_email),
                t,
                allEmails,
                favoriteEmails
              )} */}
              <FormatEmails
                emails={emailList}
                lightEntreList={lightEntreList}
                t={t}
              />
            </p>
          </div>
        ) : (
          ''
        )}
        <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
          <div className={classes.previewField}>
            <p className={classes.previewLabel}>
              {employerSide
                ? t('employer.companyProfile.label1')
                : t('assignment.col1')}
            </p>
            <p className={classes.previewValue}>{company_name}</p>
          </div>
          <br />
          <div className={classes.previewField}>
            <p className={classes.previewLabel}>
              {employerSide
                ? t('employer.previewA.col3')
                : t('assignment.col4')}
            </p>
            <p className={classes.previewValue}>{location}</p>
          </div>
          <br />
          <div className={classes.previewField}>
            <p className={classes.previewLabel}>
              {employerSide
                ? t('employer.previewA.col4')
                : t('assignment.col7')}
            </p>
            <p className={classes.previewValue}>{salaryModel}</p>
          </div>
          <br />
          <div className={classes.previewField}>
            <p className={classes.previewLabel}>
              {employerSide
                ? t('employer.previewA.col15')
                : t('assignment.label12')}
            </p>
            <p className={classes.previewValue}>
              {amount || contract_salary || unit_price || hourly_rate}
            </p>
          </div>
          <br />
          {weekly_hours !== null && (
            <div className={classes.previewField}>
              <p className={classes.previewLabel}>
                {employerSide
                  ? t('employer.previewA.col10')
                  : t('assignment.label7')}
              </p>
              <p className={classes.previewValue}>{weekly_hours}</p>
              <br />
            </div>
          )}
        </div>
        <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
          <div className={classes.previewField}>
            <p className={classes.previewLabel}>
              {employerSide
                ? t('employer.previewA.col1')
                : t('assignment.col2')}
            </p>
            <p className={classes.previewValue}>{job_title}</p>
          </div>
          <br />
          <div className={classes.previewField}>
            <p className={classes.previewLabel}>
              {employerSide
                ? t('employer.previewA.col5')
                : t('assignment.col5')}
            </p>
            <p className={classes.previewValue}>{assignmentType}</p>
          </div>
          <br />
          <div className={classes.previewField}>
            <p className={classes.previewLabel}>
              {employerSide
                ? t('employer.previewA.col8')
                : t('assignment.col8')}
            </p>
            <p className={classes.previewValue}>
              {moment(assignment_begins).format('DD.MM.YYYY')}
            </p>
          </div>
          <br />
          {assignment_ends !== null && (
            <div className={classes.previewField}>
              <p className={classes.previewLabel}>
                {employerSide
                  ? t('employer.previewA.col17')
                  : t('assignment.col10')}
              </p>
              <p className={classes.previewValue}>
                {moment(assignment_ends).format('DD.MM.YYYY')}
              </p>
              <br />
            </div>
          )}

          {!employerSide && (
            <div className={classes.previewField}>
              <p className={classes.previewLabel}>{t('assignment.col9')}</p>
              <p className={classes.previewValue}>
                {!agreement_status_entrepreneur &&
                  t(`assignmentStatus.${status}`)}
                {agreement_status_entrepreneur && offeredAssignmentStatus}
              </p>
            </div>
          )}
          <br />
        </div>
        <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
          <div className={classes.previewField}>
            <p className={classes.previewLabel}>
              {employerSide
                ? t('employer.previewA.col2')
                : t('assignment.col3')}
            </p>
            <p className={classes.previewValue}>
              {industry !== '' &&
                industry_type !== '' &&
                industryRender(
                  industry || industry_type,
                  areaOfWorkDict,
                  t,
                  employerSide ? 'employer.areaOfWork' : 'areaOfWork',
                  employerSide
                    ? 'employer.areaOfExpertiseList'
                    : 'areaOfExpertiseList'
                )}
            </p>
          </div>
          <br />
          <div className={classes.previewField}>
            <p className={classes.previewLabel}>
              {employerSide
                ? t('employer.previewA.col6')
                : t('assignment.col6')}
            </p>
            <p className={classes.previewValue}>
              {last_date_of_application &&
                moment(last_date_of_application).format('DD.MM.YYYY')}
            </p>
          </div>
          <br />
          <div className={classes.previewField}>
            <p className={classes.previewLabel}>
              {employerSide
                ? t('employer.previewA.col7')
                : t('assignment.label5')}
            </p>
            <p
              style={{ textTransform: 'capitalize', wordWrap: 'break-word' }}
              className={classes.previewValue}
            >
              {formattedTypeOfEmployment}
            </p>
          </div>
          <br />
          {notice_period && notice_period !== null && (
            <div className={classes.previewField}>
              <p className={classes.previewLabel}>
                {employerSide
                  ? t('employer.previewA.col19')
                  : t('assignment.col11')}
              </p>
              <p className={classes.previewValue}>{notice_period}</p>
              <br />
            </div>
          )}
        </div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div className={classes.previewField}>
            <p className={classes.previewLabel}>
              {employerSide
                ? t('employer.previewA.col11')
                : t('assignment.label8')}
            </p>
            <div
              dangerouslySetInnerHTML={{
                __html: job_description || assignment_contents
              }}
              style={{ paddingLeft: '20px', wordWrap: 'break-word' }}
              className={classes.previewValue}
            ></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AssignmentDetails
